import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import {
    doc,
    getDoc,
    setDoc,
} from "firebase/firestore";

import { db } from "../firebase/firebase";

export default function Services() {

    const navigate = useNavigate();

    const [loading, setLoading] =
        useState(true);

    const [services, setServices] =
        useState([]);

    const [newJson, setNewJson] =
        useState("");

    /* ---------------- FETCH ---------------- */
    useEffect(() => {

        fetchServices();

    }, []);

    const fetchServices = async () => {

        try {

            const snap = await getDoc(
                doc(
                    db,
                    "services",
                    "allServices"
                )
            );

            if (snap.exists()) {

                setServices(
                    snap.data().services || []
                );
            }

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);
        }
    };

    /* ---------------- SAVE ---------------- */
    const saveServices = async (
        updatedServices
    ) => {

        try {

            await setDoc(
                doc(
                    db,
                    "services",
                    "allServices"
                ),
                {
                    services:
                        updatedServices,
                }
            );

            setServices(updatedServices);

        } catch (err) {

            console.error(err);

            alert("Failed ❌");
        }
    };

    /* ---------------- ADD ---------------- */
    const handleAddService =
        async () => {

            try {

                if (!newJson.trim()) {

                    return alert(
                        "Paste JSON"
                    );
                }

                const parsed =
                    JSON.parse(
                        newJson
                    );

                if (
                    !parsed.title
                ) {

                    return alert(
                        "Title missing"
                    );
                }

                /* AUTO ID */
                if (
                    !parsed.id
                ) {

                    parsed.id =
                        parsed.title
                            .toLowerCase()
                            .replace(
                                /\s+/g,
                                "-"
                            );
                }

                const alreadyExists =
                    services.some(
                        (
                            service
                        ) =>
                            service.id ===
                            parsed.id
                    );

                if (
                    alreadyExists
                ) {

                    return alert(
                        "ID already exists"
                    );
                }

                /* FINAL STRUCTURE */
                const finalService =
                    {

                        id:
                            parsed.id ||
                            "",

                        title:
                            parsed.title ||
                            "",

                        slug:
                            parsed.slug ||
                            "",

                        category:
                            parsed.category ||
                            "",

                        featured:
                            parsed.featured ||
                            false,

                        isPopular:
                            parsed.isPopular ||
                            false,

                        isFeatured:
                            parsed.isFeatured ||
                            false,

                        status:
                            parsed.status ||
                            "active",

                        displayOrder:
                            parsed.displayOrder ||
                            1,

                        startingPrice:
                            parsed.startingPrice ||
                            "",

                        deliveryTime:
                            parsed.deliveryTime ||
                            "",

                        duration:
                            parsed.duration ||
                            "",

                        shortDescription:
                            parsed.shortDescription ||
                            "",

                        schemaType:
                            parsed.schemaType ||
                            "ProfessionalService",

                        hero: {

                            title:
                                parsed.hero
                                    ?.title ||
                                "",

                            subtitle:
                                parsed.hero
                                    ?.subtitle ||
                                "",

                            badge:
                                parsed.hero
                                    ?.badge ||
                                "",
                        },

                        media: {

                            thumbnail:
                                parsed
                                    .media
                                    ?.thumbnail ||
                                "",

                            banner:
                                parsed
                                    .media
                                    ?.banner ||
                                "",

                            logo:
                                parsed
                                    .media
                                    ?.logo ||
                                "",

                            gallery:
                                parsed
                                    .media
                                    ?.gallery ||
                                [],
                        },

                        serviceType:
                            parsed.serviceType ||
                            [],

                        tags:
                            parsed.tags ||
                            [],

                        highlights:
                            parsed.highlights ||
                            [],

                        features:
                            parsed.features ||
                            [],

                        technologies:
                            parsed.technologies ||
                            [],

                        techStack:
                            parsed.techStack ||
                            [],

                        industries:
                            parsed.industries ||
                            [],

                        process:
                            parsed.process ||
                            [],

                        packages:
                            parsed.packages ||
                            [],

                        pricingPlans:
                            parsed.pricingPlans ||
                            [],

                        portfolio:
                            parsed.portfolio ||
                            [],

                        testimonials:
                            parsed.testimonials ||
                            [],

                        whyChooseUs:
                            parsed.whyChooseUs ||
                            [],

                        faqs:
                            parsed.faqs ||
                            [],

                        relatedServices:
                            parsed.relatedServices ||
                            [],

                        support: {

                            maintenance:
                                parsed
                                    .support
                                    ?.maintenance ??
                                true,

                            supportDuration:
                                parsed
                                    .support
                                    ?.supportDuration ||
                                "",

                            trainingIncluded:
                                parsed
                                    .support
                                    ?.trainingIncluded ??
                                true,
                        },

                        stats: {

                            projectsCompleted:
                                parsed
                                    .stats
                                    ?.projectsCompleted ||
                                "",

                            happyClients:
                                parsed
                                    .stats
                                    ?.happyClients ||
                                "",

                            experience:
                                parsed
                                    .stats
                                    ?.experience ||
                                "",
                        },

                        theme: {

                            primary:
                                parsed
                                    .theme
                                    ?.primary ||
                                "#f97316",

                            secondary:
                                parsed
                                    .theme
                                    ?.secondary ||
                                "#3b82f6",
                        },

                        analytics: {

                            views:
                                parsed
                                    .analytics
                                    ?.views ||
                                0,

                            inquiries:
                                parsed
                                    .analytics
                                    ?.inquiries ||
                                0,
                        },

                        seo: {

                            seoTitle:
                                parsed.seo
                                    ?.seoTitle ||
                                "",

                            seoDescription:
                                parsed.seo
                                    ?.seoDescription ||
                                "",

                            seoKeywords:
                                parsed.seo
                                    ?.seoKeywords ||
                                [],
                        },

                        cta: {

                            title:
                                parsed
                                    .cta
                                    ?.title ||
                                "",

                            description:
                                parsed
                                    .cta
                                    ?.description ||
                                "",

                            primaryButton:
                                {

                                    text:
                                        parsed
                                            .cta
                                            ?.primaryButton
                                            ?.text ||
                                        "",

                                    link:
                                        parsed
                                            .cta
                                            ?.primaryButton
                                            ?.link ||
                                        "",
                                },

                            secondaryButton:
                                {

                                    text:
                                        parsed
                                            .cta
                                            ?.secondaryButton
                                            ?.text ||
                                        "",

                                    link:
                                        parsed
                                            .cta
                                            ?.secondaryButton
                                            ?.link ||
                                        "",
                                },
                        },

                        createdAt:
                            new Date().toISOString(),

                        updatedAt:
                            new Date().toISOString(),
                    };

                const updated =
                    [
                        ...services,
                        finalService,
                    ];

                await saveServices(
                    updated
                );

                setNewJson("");

                alert(
                    "Service Added ✅"
                );

            } catch (err) {

                console.error(err);

                alert(
                    "Invalid JSON ❌"
                );
            }
        };

    /* ---------------- DELETE ---------------- */
    const handleDelete =
        async (index) => {

            const confirmDelete =
                window.confirm(
                    "Delete this service?"
                );

            if (!confirmDelete)
                return;

            const updated =
                services.filter(
                    (_, i) =>
                        i !== index
                );

            await saveServices(
                updated
            );
        };

    if (loading) {

        return (
            <div className="text-white">
                Loading...
            </div>
        );
    }

    return (

        <div className="text-white">

            {/* HEADER */}
            <div className="flex justify-between items-center mb-8">

                <div>

                    <h1 className="text-3xl font-bold text-orange-500">
                        Services JSON
                    </h1>

                    <p className="text-slate-400 mt-1">
                        Add full service
                        using JSON
                    </p>

                </div>

                <button
                    onClick={() =>
                        navigate(-1)
                    }
                    className="bg-white/10 hover:bg-white/20 transition-all px-4 py-2 rounded-lg"
                >
                    Back
                </button>

            </div>

            {/* JSON BOX */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8">

                <textarea
                    rows={22}
                    value={newJson}
                    onChange={(e) =>
                        setNewJson(
                            e.target
                                .value
                        )
                    }
                    placeholder="Paste Service JSON..."
                    className="w-full p-4 rounded-2xl bg-black/40 border border-white/20 font-mono text-sm"
                />

                <button
                    onClick={
                        handleAddService
                    }
                    className="mt-5 bg-orange-500 hover:bg-orange-600 transition-all px-6 py-3 rounded-xl font-medium"
                >
                    Add Service
                </button>

            </div>

            {/* SERVICES */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">

                {services.map(
                    (
                        service,
                        index
                    ) => (

                        <div
                            key={index}
                            className="bg-white/5 border border-white/10 rounded-2xl p-5"
                        >

                            <h3 className="text-xl font-semibold">

                                {
                                    service.title
                                }

                            </h3>

                            <p className="text-sm text-slate-400 mt-2">

                                ID:
                                {" "}
                                {service.id}

                            </p>

                            <div className="flex gap-3 mt-5">

                                <button
                                    onClick={() =>
                                        navigate(
                                            `/dashboard/service-view?id=${service.id}`
                                        )
                                    }
                                    className="flex-1 bg-orange-500 hover:bg-orange-600 transition-all px-4 py-2 rounded-lg text-sm"
                                >
                                    View
                                </button>

                                <button
                                    onClick={() =>
                                        handleDelete(
                                            index
                                        )
                                    }
                                    className="flex-1 bg-red-600 hover:bg-red-700 transition-all px-4 py-2 rounded-lg text-sm"
                                >
                                    Delete
                                </button>

                            </div>

                        </div>

                    )
                )}

            </div>

        </div>
    );
}